import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withScopeContext } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { Table, TableWrapperElement } from '@mews-commander/ui/legacy';
import { getServiceResourceTableRows } from '../../../../../selectors/guestOverview';
import { getTableMapping } from './utils';
import { SpaceTableOwnProps, TableRowData } from './types';

type NightsTableProps = StateProps & SpaceTableOwnProps;

const NightsTable = ({ resourceTableRows, editProfile, billingScreen, editInternals }: NightsTableProps) => {
    const mapping = getTableMapping({ editProfile, billingScreen, editInternals });

    return (
        <TableWrapperElement>
            <Table mapping={mapping} source={resourceTableRows} />
        </TableWrapperElement>
    );
};

interface OwnProps {
    serviceId: string;
}

interface StateProps {
    resourceTableRows: TableRowData[];
}

export default withScopeContext(
    connect(
        createStructuredSelector<ApplicationState, SpaceTableOwnProps & OwnProps, StateProps>({
            resourceTableRows: (state: ApplicationState, { scope, serviceId }) => {
                const enterpriseId = getCurrentEnterpriseId();
                return getServiceResourceTableRows(state, {
                    enterpriseId,
                    serviceId,
                    scope,
                });
            },
        })
    )(NightsTable)
);
